import Barcode from 'eflex/components/jem/task/barcode';
import Button from 'eflex/components/jem/task/button';
import Decision from 'eflex/components/jem/task/decision';
import Edhr from 'eflex/components/jem/task/edhr';
import ErrorProofing from 'eflex/components/jem/task/error-proofing';
import ImageCapture from 'eflex/components/jem/task/image-capture';
import Multispindle from 'eflex/components/jem/task/multispindle';
import NodeRed from 'eflex/components/jem/task/node-red';
import Pick from 'eflex/components/jem/task/pick';
import Plc from 'eflex/components/jem/task/plc';
import Print from 'eflex/components/jem/task/print';
import PushToSchedule from 'eflex/components/jem/task/push-to-schedule';
import SerialNumberTransfer from 'eflex/components/jem/task/serial-number-transfer';
import Timer from 'eflex/components/jem/task/timer';
import Torque from 'eflex/components/jem/task/torque';
import UploadFile from 'eflex/components/jem/task/upload-file';
import ViewFile from 'eflex/components/jem/task/view-file';
import Vision from 'eflex/components/jem/task/vision';
import NoDisplay from 'eflex/components/jem/task/no-display';

export default (taskType) => {
  switch (taskType) {
    case 'barcode': {
      return Barcode;
    }
    case 'button': {
      return Button;
    }
    case 'decision': {
      return Decision;
    }
    case 'edhr': {
      return Edhr;
    }
    case 'errorProofing': {
      return ErrorProofing;
    }
    case 'imageCapture': {
      return ImageCapture;
    }
    case 'multispindle': {
      return Multispindle;
    }
    case 'nodeRed': {
      return NodeRed;
    }
    case 'pick': {
      return Pick;
    }
    case 'plc': {
      return Plc;
    }
    case 'print': {
      return Print;
    }
    case 'pushToSchedule': {
      return PushToSchedule;
    }
    case 'serialNumberTransfer': {
      return SerialNumberTransfer;
    }
    case 'timer': {
      return Timer;
    }
    case 'torque': {
      return Torque;
    }
    case 'uploadFile': {
      return UploadFile;
    }
    case 'viewFile': {
      return ViewFile;
    }
    case 'vision': {
      return Vision;
    }
    default: {
      return NoDisplay;
    }
  }
};
